export default "__VITE_ASSET__a3d7e7d8__"